import { render, staticRenderFns } from "./GeracaoDistribuida.vue?vue&type=template&id=0c445c4e&"
import script from "./GeracaoDistribuida.vue?vue&type=script&lang=js&"
export * from "./GeracaoDistribuida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports